var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column flex-sm-row align-center my-10"},[_c('img',{directives:[{name:"a11y-clickable",rawName:"v-a11y-clickable"}],staticClass:"image clickable",attrs:{"src":_vm.slice.items[0].image.url,"alt":_vm.slice.items[0].image.alt || 'Featured Image'},on:{"click":_vm.handleClick}})])
}
var staticRenderFns = []

export { render, staticRenderFns }